"use client";

import { AppPageTitle } from "@/widgets";
import SolutionCooperationSection from "@/widgets/app/page/solution/SolutionCooperationSection";
import SolutionGroGroSection from "@/widgets/app/page/solution/SolutionGroGroSection";
import SolutionSynergySection from "@/widgets/app/page/solution/SolutionSynergySection";
import SolutionWalletSection from "@/widgets/app/page/solution/SolutionWalletSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function SolutionPage() {
  return (
    <SsgoiTransition id="/app/pages/solution">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        {/* 솔루션  */}
        <SolutionCooperationSection />
        {/* 한밭페이 */}
        <SolutionWalletSection />
        {/* 그루그루 */}
        <SolutionGroGroSection />
        {/* 시너지 */}
        <SolutionSynergySection />
      </div>
    </SsgoiTransition>
  );
}
